<template>

  <div class="mainCanvasContainer">
    <div class="mainCanvasFixed">
      <div class="mainCanvasFixedSidePanel">
        <el-button icon="el-icon-arrow-left" type="info" plain size="small"></el-button>

      </div>


    </div>
    <div class="mainCanvasFixedToggle">
      <div class="mainCanvasFixedSidePanelToggle">
        <el-collapse accordion>
          <el-collapse-item name="1">
            <template slot="title">
              Core<i class="header-icon el-icon-info"></i>
            </template>
            <div>Consistent with real life: in line with the process and logic of real life, and comply with languages and habits that the users are used to;</div>
            <div>Consistent within interface: all elements should be consistent, such as: design style, icons and texts, position of elements, etc.</div>
          </el-collapse-item>
          <el-collapse-item title="Linkages" name="2">
            <div>Operation feedback: enable the users to clearly perceive their operations by style updates and interactive effects;</div>
            <div>Visual feedback: reflect current state by updating or rearranging elements of the page.</div>
          </el-collapse-item>
          <el-collapse-item title="Additions" name="3">
            <div>Simplify the process: keep operating process simple and intuitive;</div>
            <div>Definite and clear: enunciate your intentions clearly so that the users can quickly understand and make decisions;</div>
            <div>Easy to identify: the interface should be straightforward, which helps the users to identify and frees them from memorizing and recalling.</div>
          </el-collapse-item>

        </el-collapse>
      </div>


    </div>
    <div class="CanvasContainer">

      <div class="CanvasHeader">
        <TimelineGridColGroup
          v-for="(item, index) in this.$store.state.years"
          :timelinezoomlevel="timelinezoomlevel"

          :ColStart="item.startdate"
          :ColEnd="item.enddate"
          :startdate="item.startdate"
          :enddate="item.enddate"
          RowStart=0.0
          RowEnd=200
          :Message="item.year"
          v-if='years=true'

          Type=1>
        </TimelineGridColGroup>

        <TimelineGridColGroup
          v-if='months'

          v-for="(item, index) in this.$store.state.months"
          :timelinezoomlevel="timelinezoomlevel"

          :ColStart="item.startdate"
          :ColEnd="item.enddate"
          :startdate="item.startdate"
          :enddate="item.enddate"
           RowStart=0.6
           RowEnd=200
           :Message="item.month"
           Type=2>
         </TimelineGridColGroup>

      </div>
      <div class="mainCanvasFlex-item">
        <div class="CanvasMain">
          <div class="gridwrapperCanvas" :style="gridStyle">

            <TimelineGridColGroup
              v-for="(item, index) in this.$store.state.years"
              :timelinezoomlevel="timelinezoomlevel"

              :ColStart="item.startdate"
              :ColEnd="item.enddate"
              :startdate="item.startdate"
              :enddate="item.enddate"
              RowStart=0.0
              RowEnd=200
              :Message="item.year"
              v-if='years=true'
              :header="false"
              Type=1>
            </TimelineGridColGroup>

            <TimelineGridColGroup
              v-if='months'

              v-for="(item, index) in this.$store.state.months"
              :timelinezoomlevel="timelinezoomlevel"
              :header="false"

              :ColStart="item.startdate"
              :ColEnd="item.enddate"
              :startdate="item.startdate"
              :enddate="item.enddate"
               RowStart=0
               RowEnd=200
               :Message="item.month"
               Type=2>
             </TimelineGridColGroup>
               <div class="ForecastLine" :style="gridStyle"></div>

               <CanvasOmniBlock
                  v-if="selectedScenarioComp.mode=='model'"
                  v-for="(item, index) in this.CanvasGroupsDisplay5"
                  :scenarioset="selectedScenarioComp.id"
                 :blocks="item"
                 :timelinezoomlevel="timelinezoomlevel"

                 >
               </CanvasOmniBlock>

            <CanvasScenarioBlock
              v-if="selectedScenarioComp.mode=='scenario'"
              :scenarioIn="this.selectedScenarioComp"
              :CanvasGroupsIn="this.$store.state.CanvasGroups"
              :timelinezoomlevel="timelinezoomlevel"
            >
            </CanvasScenarioBlock>


           </div>
        </div>
      </div>




    </div>
    <div class="CanvasFooter">

      <div class="row">
        <div class="column left" >
          <el-button-group>
            <el-button type="primary" icon="el-icon-document" size="mini" v-for="(item, index) in this.$store.state.ScenarioSets"@click="SecenarioTabSelect(item.id)" :type="buttonType(item.mode)">{{item.name}}</el-button>
          </el-button-group>
          <el-button-group>
            <el-button  icon="el-icon-arrow-left" size="mini"></el-button>
            <el-button  size="mini"><i class="el-icon-arrow-right"></i></el-button>
          </el-button-group>
          <el-button-group>
            <el-button  icon="el-icon-document-add" size="mini"></el-button>
            <el-button  icon="el-icon-delete" size="mini"></el-button>
          </el-button-group>
          <el-button-group>
            <el-button  icon="el-icon-data-line" size="mini" @click="chartToggle()"></el-button>
            <el-button  icon="el-icon-lock" size="mini"></el-button>
            <el-button  icon="el-icon-unlock" size="mini"></el-button>

          </el-button-group>


          <!-- <el-button  size="small" icon="el-icon-s-unfold" circle @click="expandSubBlock()" circle>22</el-button> -->

        </div>
        <div class="column middle" >
          <el-radio-group @change="handledatefrequencyChange" v-model="datefrequency" size="mini">
             <el-radio-button label="days">Days</el-radio-button>
             <el-radio-button label="weeks">Weeks</el-radio-button>
             <el-radio-button label="months">Months</el-radio-button>
             <el-radio-button label="years">Years</el-radio-button>
          </el-radio-group>
        </div>
        <div class="column right" >
          <el-slider
            size="mini"
            show-input
            v-if="!isCollapse"
            v-model="colwidth"
            :step="10"

            show-stops>
          </el-slider>
        </div>
      </div>




    </div>

  </div>









</template>

<style>

.el-collapse-item__header {
    display: flex;
    align-items: center;
    height: 48px;
    line-height: 48px;
    background-color: #f1f1f1;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #dcdfe6;
    font-size: 13px;
    font-weight: 500;
    transition: border-bottom-color .3s;
    outline: 0;
}
.el-collapse-item__content {
    padding-bottom: 25px;
    font-size: 13px;
    /* color: #303133; */
    padding-left: 10px;

    background-color: #f5f7f8;

    line-height: 1.769230769230769;
}
.mainCanvasContainer {
    background-color:#2E4272;
    display:flex;
}
.mainCanvasFixed {
    background-color:#003950;
}
.mainCanvasFixedToggle {
    background-color:blue;
}
.mainCanvasFixedSidePanel {
    background-color:#f1f1f1;
    border-right: 1px solid #dcdfe6;
    width: 50px;
    font-size: larger;
    height: 100%;
    position:relative;
    padding-right: 0px;
    text-align: center;
    font-weight: bolder;
}
.mainCanvasFixedSidePanelToggle {
    background-color:#f1f1f1;
    border-right: 1px solid #003950;
    width: 200px;
    left: 0px;
    height: 100%;
    position:relative;
}
.mainCanvasFlex-item {
    background-color:#7887AB;
    flex-grow: 1;
}

  /* Create three unequal columns that floats next to each other */
  .column {
    float: left;
    padding: 10px;
    height: 300px; /* Should be removed. Only for demonstration */
    box-sizing: border-box;
    background-color: #f1f1f1;


  }

  .left {
    width: 25%;
    background-color: #f1f1f1;
  }

   .right {
    width: 15%;
    background-color: #f1f1f1;
  }

  .middle {
    width: 60%;
    text-align: right;
    background-color: #f1f1f1;
  }

  /* Clear floats after the columns */
  .row:after {
    content: "";
    display: table;
    clear: both;
  }
  .CanvasContainer {
    height: 100%;
    width: 100%;
    top:0px;
    position: relative;
  }

  .CanvasMain {
    width: 100%;
    overflow-y: scroll;
    height: 10000px;

    position: relative;
    display: flex;
  }
  .CanvasFooter {
    position: fixed;
    bottom:0;
    width: 100%;
    background-color: #f1f1f1;
    border-top: 1px solid #003950;
    color: #003950;
    height: 45px;
    padding-top: 5px;
    text-align: left;
    vertical-align: middle;
    z-index: 1000000;
  }

  .CanvasHeader {
    position: relative;
    top:0px;
    background-color: blue;
    background-color: #f1f1f1;
    color: #003950;
    height: 35px;
    width: 100%;
  }

  .gridwrapperCanvas {
      position:relative;
      /* margin-bottom: 100px; */

      overflow-x: scroll;
      overflow-y: scroll;

      width: var(--grid-width);
      height: var(--grid-height);
      /* height: 50000px; */

      background-color: #fff;
      color: #444;
      background: repeating-linear-gradient(
      to right,
      #f1f1f1,
      #f1f1f1 var(--col-width),
      #f5f7f8 var(--col-width),
      #f5f7f8 calc(var(--col-width)*2)

    );

    }

  .ForecastLine {
    position: absolute;
    left: var(--forecast-start);
    top: 14px;
    width: 0px;
    height: 10000px;
    background-color: #f1f1f1;

    border: 3px dashed #333333;
  },
  .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

</style>
<script>
// @ is an alias to /src
import TimelineGridColGroup from '@/components/Timeline/Timeline-Grid-ColGroup.vue'
import TimelineGridColGroupMonth from '@/components/Timeline/Timeline-Grid-ColGroupMonth.vue'

import CanvasOmniBlock from '@/components/Canvas/Canvas-Omni-Block.vue'
import CanvasScenarioBlock from '@/components/Canvas/Canvas-Scenario-Block.vue'

//
// import CanvasGroup from '@/components/Canvas/Canvas-Group.vue'
// import VueDraggableResizable from 'vue-draggable-resizable'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueDragResize from 'vue-drag-resize'


export default {
  name: 'Canvas',
  components: {
    TimelineGridColGroup, TimelineGridColGroupMonth,
    //CanvasGroup, VueDraggableResizable,
    CanvasOmniBlock,CanvasScenarioBlock,VueDragResize

  },
  data: function () {
    return {
      timelinezoomlevel: "months",
      selectedScenario: "",
      activeNames: '',
      datefrequency: "months",
      colwidth: 10,
      years: false,
      months: true,
      days: false,
      weeks: false,
      drawer: false,
      direction: 'ltr',
      isCollapse: false,
      marks: {
        10: '10',
        20: '20',
        30: '30',
        40: '40',
        50: '50',
        60: '60',
        70: '70',
        80: '80',
        90: '90',
        100: '100'
      },
      width: 500,
      height: 300,
      top: 0,
      left: 0,
      width2: 250,
      height2: 150,
      top2: 50,
      left2: 50

    }
  },
  beforeCreate: function() {
      //this.$store.dispatch("init");
      console.log("beforeCreate in Canvas############################# &&&&&&&&&&&&&&&&&&&")


      var colWidth = JSON.parse(JSON.stringify(this.$store.state.colWidth));
      var startyear = JSON.parse(JSON.stringify(this.$store.state.startyear));
      var endyear = JSON.parse(JSON.stringify(this.$store.state.endyear));

      var years = []
      var months = []
      var days = []

      function numberOfDays(year, month) {
          var d = new Date(year, month+1,0);
          // console.log(d)
          return d.getDate();
      }

      for(let y=startyear; y<=endyear; y++){

        var ystartdate = new Date(y,0,1)
        var yenddate = new Date(y,12,1)
        years.push({year:y, startdate: ystartdate, enddate:yenddate})

        for(let m=0; m<12; m++){

          var mstartdate = new Date(y,m,1)
          var menddate = new Date(y,m+1,1)
          months.push({month:m+1, startdate: mstartdate, enddate:menddate})

          for(let d=1; d<(numberOfDays(y, m)+0); d++){

            var dstartdate = new Date(y,m,d)
            var denddate = new Date(y,m,d+1)
            days.push({day:d, startdate: dstartdate, enddate:denddate})


          }
        }
      }

      console.log("years",years)
      console.log("months",months)
      console.log("days",days)

      var getDaysArray = function(start, end) {
          for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
              arr.push(new Date(dt));
          }
          return arr;
      };

      var daylist = getDaysArray(new Date(startyear,0,1),new Date(endyear,11,1));
      console.log("daylist",daylist)

      var FirstOfMonth=[]
      for(let d=0; d<daylist.length; d++){
        if(daylist[d].getDate()==1){
          FirstOfMonth.push(daylist[d])
        }
      }
      console.log("FirstOfMonth",FirstOfMonth,FirstOfMonth)


      this.$store.dispatch('updateDateIndex',[daylist,years,months,days,FirstOfMonth])
      // var DateIndexclone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      this.$store.dispatch('BuildOutputBlocks',1)

      this.$store.dispatch('UpdateOutputBlocks',"all")


    },
  created: function () {

      this.$store.dispatch('BuildActiveTree',1)

  },
  watch: {
    colwidth: function() {


      // store previous colwidth

      this.$store.dispatch('UpdatecolWidth',[this.colwidth])


    }

  },
  methods: {
    chartToggle(){
      var toggle=JSON.parse(JSON.stringify(this.$store.state.showCharts))
      this.$store.dispatch('chartToggle',[!toggle])

    },

    SecenarioTabSelect(scenario){
      console.log("SecenarioTabSelect",scenario)

      var clone=JSON.parse(JSON.stringify(this.$store.state.ScenarioSets))

      var index0 = clone.findIndex((v) => {
        return v.id==scenario[0];
      });


      this.selectedScenario=clone[index0]
    },

    handledatefrequencyChange(){
      var input = this.datefrequency
      console.log(input)


      var colWidth = JSON.parse(JSON.stringify(this.$store.state.colWidth));

      var startyear = JSON.parse(JSON.stringify(this.$store.state.startyear));
      var endyear = JSON.parse(JSON.stringify(this.$store.state.endyear));




      function numberOfDays(year, month) {
          var d = new Date(year, month+1,0);
          // console.log(d)
          return d.getDate();
      }
      function days_of_a_year(year) {

        return isLeapYear(year) ? 366 : 365;
      }

      function isLeapYear(year) {
           return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
      }



      var getDaysArray = function(start, end) {
          for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
              arr.push(new Date(dt));
          }
          return arr;
      };

      if(input=="days"){
        this.timelinezoomlevel=input
        this.years=true
        this.months=true
        this.weeks=true
        this.days=true
        this.colwidth=10
        this.$store.dispatch('UpdatecolWidth',[this.colwidth])

        //console.log("this.months",this.months)


      }else if (input=="months") {
        this.timelinezoomlevel=input
        this.years=true
        this.months=true
        this.colwidth=30
        this.$store.dispatch('UpdatecolWidth',[this.colwidth])

        //console.log("this.months",this.months)


      }else if (input=="years") {
        this.timelinezoomlevel=input
        this.years=true
        this.months=false
      }


      var daylist = getDaysArray(new Date(startyear,0,1),new Date(endyear,11,1));
      //console.log("daylist",daylist)

      var FirstOfMonth=[]
      for(let d=0; d<daylist.length; d++){
        if(daylist[d].getDate()==1){
          FirstOfMonth.push(daylist[d])
        }
      }
      //console.log("FirstOfMonth",FirstOfMonth,FirstOfMonth)
      //console.log("months",months)

    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    findDateIndex(DateIndex,DateToFind) {

      var index = DateIndex.findIndex((v) => {
        return new Date(v).getTime()===new Date(DateToFind).getTime();
      });

        return index;
    },
    showmenu() {
      this.isCollapse=!this.isCollapse
    },
    buttonType (mode) {
      if(mode=="scenario"){
        var type="success"
      }else if(mode=="model"){
        var type="primary"
      }else{
        var type="info"
      }
      return type

    }
  },

  computed: {

    selectedScenarioComp () {
      if(this.selectedScenario==""){

        this.selectedScenario=this.$store.state.ScenarioSets[0]

      }
      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))

      return this.selectedScenario

    },

    gridStyle () {
      //Determine sizes and initialize parameters for the Canvas
      //find the proper Date index values reltaive to the start of the analysis window
      var colWidth = this.$store.state.colWidth;
      var forecastStart =this.$store.state.forecastDateRange[0]
      var forecastStartDate =new Date(forecastStart.year,(forecastStart.month-1),forecastStart.day)
      var clone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      var clone1 = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));

      //console.log("looking for this date",forecastStartDate, "in", clone)


      var index = clone.findIndex((v) => {
        return new Date(v).getTime()===new Date(forecastStartDate).getTime();
      });

      var foundIndex = this.findDateIndex(clone,forecastStartDate)
      //console.log("foundIndex",foundIndex)

      if(this.timelinezoomlevel=="days"){
        var width=colWidth*this.$store.state.days.length
      }else{
        var width=colWidth*this.$store.state.months.length

      }

      if(this.timelinezoomlevel=="days"){
        //console.log("looking for DateIndex")

        var startDate =forecastStartDate


        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)


        var x = foundIndex*this.$store.state.colWidth

      }else{
        //console.log("looking for MonthIndex")
        if(forecastStartDate.getDate()<15){
          var startDate =new Date(forecastStartDate.getFullYear(),(forecastStartDate.getMonth()),1)

        }else{
          var startDate =new Date(forecastStartDate.getFullYear(),(forecastStartDate.getMonth()+1),1)

        }


        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone1,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)


        var x = foundIndex*this.$store.state.colWidth
      }

      return {

      '--col-width': `${colWidth}px`,
      '--grid-width':`${width}px`,
      '--grid-height':`${1000000}px`,
      '--forecast-start':`${x}px`,

      }
    },
    CanvasGroupsDisplay5 () {

      console.log("selectedScenarioComp",this.selectedScenarioComp)

      var clone=JSON.parse(JSON.stringify(this.$store.state.CanvasGroups))
      var clone1=[]
      for(let s=0; s<this.selectedScenarioComp.CanvasGroups.length; s++){
        //console.log("looking for",this.selectedScenarioComp.CanvasGroups[s])
        //determine which CanvasGroup to search:
        var index0 = clone.findIndex((v) => {
          return v.id==this.selectedScenarioComp.CanvasGroups[s];
        });

        clone1.push(clone[index0])
      }


      // console.log("clone",clone)
      // console.log("index0",index0)
      // console.log("clone1",clone1)


      let rows = [3];
      let headers = [2,2,2,2]
      let minsize = [2,2,2,2]
      var flatcontainer = []

      for(let r=0; r<clone1.length; r++){


        var temptree = getTreeHeight(clone1[r],rows,flatcontainer)
        clone1[r]=temptree[0]
        rows=temptree[1]
        flatcontainer=temptree[2]
        rows.push(rows[rows.length-1]+3)

      }

      function getTreeHeight(tree,rows,flatcontainer){
        //console.log("tree",tree)
          if(tree.id.length==2){

            rows.push(rows[rows.length-1]+3)
          }

          tree.y=rows[rows.length-1]

          //expand rows based on number, status and size of children
          if(tree.status==0){
            //not shown
            //rows.push(rows[rows.length-1]+8)

          }else if (tree.status==1) {
            //header only
            rows.push(rows[rows.length-1]+5)

          }else if (tree.status==2) {
            //full content
            rows.push(rows[rows.length-1]+8)

          }


          if(tree.hasOwnProperty("children")){
            //console.log("has children",tree.children)
            for (let c=0; c<tree.children.length; c++) {
              var childtree=getTreeHeight(tree.children[c],rows,flatcontainer)
              tree.children[c]=childtree[0]
              rows=childtree[1]
              flatcontainer=childtree[2]
            }
          }
          tree.h=rows[rows.length-1]-tree.y
          if(tree.status>0){

            flatcontainer.push(tree)

          }


        return [tree,rows,flatcontainer]
      }

        //console.log("flatcontainer",flatcontainer)
        //this.$store.dispatch('VDRpreventActiveBehavior',1)

        return flatcontainer
    }



  }

}
</script>
